import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { DropTarget } from "react-dnd";
import { FILE_TYPE } from "constants/drag-drop-types";

import "styles/file-snapshot.css";

class FileSnapshot extends React.Component {
    render() {
        const { record, document, connect } = this.props;
        return (
            <div
                className={cx("mx-15 my-15 file-snapshot", {
                    shadow: record
                })}
                ref={connect}
            >
                <div className={"file-uploader"}>
                    {record && record.get("data").id ? (
                        <div
                            className={
                                "d-flex flex-column align-items-center w-100"
                            }
                        >
                            <div className={"p-5"} style={{ height: "75px" }} />
                            <div
                                className={"p-5 text-align-center w-100"}
                                style={{ color: "#fff", height: "75px" }}
                            >
                                <a
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                    href={record.get("data").file}
                                >
                                    {record.get("data").file_name}
                                </a>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className={"file-label p-5"}>
                    <p>{document.document_name}</p>
                </div>
            </div>
        );
    }
}

FileSnapshot.propTypes = {
    document: PropTypes.object,
    record: PropTypes.object,
    associate: PropTypes.number,
    bank: PropTypes.number,
    connect: PropTypes.func,
    canDrop: PropTypes.bool
};

const DragSpec = {
    canDrop: (props, monitor) => monitor.getItemType() === FILE_TYPE,
    drop(props) {
        return {
            recordId: props.record ? props.record.id : null, //existing record id
            documentId: props.document.id,
            documentType: props.document.document_type,
            associate: props.associate,
            bank: props.bank
        };
    }
};

const DragCollector = (connect, monitor) => ({
    connect: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
});

export default DropTarget(FILE_TYPE, DragSpec, DragCollector)(FileSnapshot);
